<template>
  <div class="reservat">
    <el-badge :value="waitingNum" class="waiting-item">
      <el-tabs
        v-model="reservatStatus"
        type="border-card"
        @tab-click="changeStudent"
      >
        <el-tab-pane label="全部" name="全部"></el-tab-pane>
        <el-tab-pane label="待办" name="waiting"></el-tab-pane>
        <el-tab-pane label="报备" name="reservation"></el-tab-pane>
        <el-tab-pane label="带看" name="visit"></el-tab-pane>
        <el-tab-pane label="认购" name="recognition"></el-tab-pane>
        <el-tab-pane label="签约" name="netSign"></el-tab-pane>
      </el-tabs>
    </el-badge>

    <div class="main-filter">
      <div class="filter">
        <div>
          <el-input
            v-model="query.filter"
            class="search-name input-with-select"
            reserve-keyword
            clearable
            :placeholder="searchText"
            @clear="getReservationList"
            @keyup.enter.native="enterSearch"
          >
            <el-select
              v-model="searchText"
              slot="prepend"
              placeholder="全文搜索"
              @change="filterSelect"
            >
              <el-option label="客户姓名" value="请输入客户姓名"></el-option>
              <el-option
                label="客户手机号"
                value="请输入客户手机号"
              ></el-option>
              <el-option
                label="全文搜索"
                value="请输入客户姓名/客户手机号"
              ></el-option>
            </el-select>
          </el-input>
          <el-button
            type="primary"
            @click="getReservationList"
            class="filter-btn"
            >查询</el-button
          >
          <el-button type="text" class="delete-btn" @click="deleteFilter"
            ><i class="el-icon-delete el-icon--right"></i>清空全部</el-button
          >
        </div>
        <div class="operation">
          <el-button
            type="primary"
            @click="toCreateReservat"
            v-if="query.flowStatus == 'reservation'"
            >添加报备</el-button
          >
          <el-button
            type="primary"
            @click="exportReservation"
            :disabled="reservationList.length == 0"
            :loading="isLoadingDownload"
            >下载报表</el-button
          >
        </div>
      </div>
      <div class="filter-select">
        <div class="filter-item">
          <span class="filter-tit">楼盘</span>
          <el-select
            v-model="query.estateId"
            @change="getReservationList"
            filterable
            remote
            @visible-change="estateVisibleChange"
            :remote-method="getEstates"
            @clear="estates = []"
            placeholder="请输入楼盘名称"
            clearable
            :no-data-text="noDataText"
          >
            <el-option
              v-for="item in estates"
              :key="item.id"
              :label="item.name"
              :value="item.id"
            ></el-option>
          </el-select>
        </div>
        <div class="filter-item">
          <span class="filter-tit">经纪人</span>
          <el-select
            v-model="query.brokerId"
            placeholder="请输入经纪人姓名/电话"
            filterable
            remote
            clearable
            :remote-method="getUsersSearch"
            @visible-change="userVisibleChange"
            @change="getReservationList"
            :no-data-text="noDataText"
            @clear="creatorlist = []"
          >
            <el-option
              v-for="item in creatorlist"
              :key="item.id"
              :label="item.name"
              :value="item.id"
              v-show="item.name"
            >
              <span style="float: left">{{ item.name }}</span>
              <span
                style="
                  float: right;
                  color: #8492a6;
                  font-size: 13px;
                  width: 100px;
                  text-align: right;
                  white-space: nowrap;
                  overflow: hidden;
                  text-overflow: ellipsis;
                "
                >{{ item.organizationUnit }}</span
              >
            </el-option>
          </el-select>
        </div>
        <div class="filter-item">
          <span class="filter-tit">渠道</span>
          <el-select
            v-model="query.channelId"
            placeholder="请输入渠道人员姓名/电话"
            filterable
            remote
            clearable
            :remote-method="getChannelSearch"
            @visible-change="channelVisibleChange"
            @change="getReservationList"
            :no-data-text="noDataText"
            @clear="channellist = []"
          >
            <el-option
              v-for="item in channellist"
              :key="item.id"
              :label="item.name"
              :value="item.id"
              v-show="item.name"
            >
              <span style="float: left">{{ item.name }}</span>
              <span
                style="
                  float: right;
                  color: #8492a6;
                  font-size: 13px;
                  width: 100px;
                  text-align: right;
                  white-space: nowrap;
                  overflow: hidden;
                  text-overflow: ellipsis;
                "
                >{{ item.organizationUnit }}</span
              >
            </el-option>
          </el-select>
        </div>
        <div class="filter-item">
          <span class="filter-tit">门店</span>
          <el-select
            v-model="query.organizationUnitId"
            @change="getReservationList"
            filterable
            remote
            :remote-method="getOrgs"
            @visible-change="orgVisibleChange"
            @clear="clearOrg"
            placeholder="请输入门店名称/地址"
            :no-data-text="noDataText"
            clearable
          >
            <el-option
              v-for="item in orgList"
              :key="item.id"
              :label="item.name"
              :value="item.id"
            ></el-option>
          </el-select>
        </div>
        <div
          v-if="
            this.reservatStatus == 'waiting' || this.reservatStatus == '全部'
          "
          class="flex filter-item"
        >
          <span class="filter-tit">报备时间</span>
          <el-date-picker
            v-model="createDaterange"
            type="daterange"
            unlink-panels
            range-separator="~"
            start-placeholder="开始日期"
            end-placeholder="结束日期"
            @change="getReservationList"
            value-format="yyyy-MM-dd HH:mm:ss"
            :default-time="['00:00:00', '23:59:59']"
          ></el-date-picker>
        </div>

        <div
          v-if="
            this.reservatStatus != 'waiting' && this.reservatStatus != '全部'
          "
          class="flex filter-item"
        >
          <span class="filter-tit">{{ searchTime }}</span>
          <el-date-picker
            v-model="lastModificationTime"
            type="daterange"
            unlink-panels
            range-separator="~"
            start-placeholder="开始日期"
            end-placeholder="结束日期"
            @change="getReservationList"
            value-format="yyyy-MM-dd HH:mm:ss"
            :default-time="['00:00:00', '23:59:59']"
          ></el-date-picker>
        </div>
        <div v-if="reservatStatus != 'waiting'" class="filter-item">
          <span class="filter-tit">审核状态</span>
          <el-select
            v-model="query.reviewStatus"
            clearable
            placeholder="请选择状态"
            @change="getReservationList"
          >
            <el-option
              v-for="item in statusOptions"
              :key="item.value"
              :label="item.label"
              :value="item.value"
            >
            </el-option>
          </el-select>
        </div>
      </div>
    </div>
    <el-table :data="reservationList" border>
      <el-table-column
        label="楼盘名称"
        :resizable="false"
        align="left"
        show-overflow-tooltip
      >
        <template slot-scope="scope">
          <span class="todetails" @click="toEstate(scope.row.estateId)">{{
            scope.row.estateName | nullValue
          }}</span>
        </template>
      </el-table-column>
      <el-table-column label="客户" :resizable="false" align="left">
        <template slot-scope="scope">
          <span class="todetails" @click="toCustomer(scope.row.customerId)">{{
            scope.row.customerName | nullValue
          }}</span>
        </template>
      </el-table-column>
      <el-table-column
        label="经纪人"
        :resizable="false"
        align="left"
        show-overflow-tooltip
      >
        <template slot-scope="scope">
          {{ scope.row.creatorName | nullValue
          }}<span v-if="scope.row.organizationUnit"
            >({{ scope.row.organizationUnit | nullValue }})</span
          >
        </template>
      </el-table-column>
      <el-table-column
        label="渠道"
        :resizable="false"
        align="left"
        show-overflow-tooltip
      >
        <template slot-scope="scope">
          {{ scope.row.channelName | nullValue
          }}<span v-if="scope.row.channelOrganizationUnit"
            >({{ scope.row.channelOrganizationUnit | nullValue }})</span
          >
        </template>
      </el-table-column>
      <el-table-column
        :label="searchTime"
        :resizable="false"
        align="left"
        min-width="120"
      >
        <template slot-scope="scope">
          <span
            v-if="
              reservatStatus == '全部' ||
              reservatStatus == 'waiting' ||
              reservatStatus == 'reservation'
            "
          >
            {{ scope.row.creationTime | nullValue }}
          </span>
          <span v-if="reservatStatus == 'visit'">
            {{ scope.row.lastVisitTime | nullValue }}
          </span>
          <span v-if="reservatStatus == 'recognition'">
            {{ scope.row.lastRecognitionTime | nullValue }}
          </span>
          <span v-if="reservatStatus == 'netSign'">
            {{ scope.row.lastNetSignTime | nullValue }}
          </span>
        </template>
      </el-table-column>
      <el-table-column label="状态" :resizable="false" align="left">
        <template slot-scope="scope">
          {{ scope.row.flowStatus | nullValue }}
          <span
            v-if="scope.row.reviewStatus"
            :class="
              scope.row.reviewStatus == '已通过'
                ? 'success'
                : scope.row.reviewStatus == '已驳回'
                ? 'error'
                : 'waiting'
            "
            >（{{ scope.row.reviewStatus }}）</span
          >
        </template>
      </el-table-column>
      <el-table-column
        label="操作"
        width="250"
        :resizable="false"
        align="left"
        fixed="right"
      >
        <template slot-scope="scope">
          <div v-if="reservatStatus == 'waiting'">
            <el-button type="text" @click="showCopy(scope.row)"
              >复制报备</el-button
            >
            <el-button type="text" @click="edit(scope.row)">详情</el-button>
            <el-button
              type="text"
              v-if="scope.row.reviewStatus == '待审核'"
              @click="updateStatus(scope.row, true)"
              >通过</el-button
            >
            <el-button
              type="text"
              v-if="scope.row.reviewStatus == '待审核'"
              @click="updateStatus(scope.row, false)"
              >驳回</el-button
            >
          </div>
          <div v-if="reservatStatus == 'reservation'">
            <el-button type="text" @click="edit(scope.row)">详情</el-button>
            <el-button
              type="text"
              v-if="scope.row.reviewStatus == '待审核'"
              @click="updateStatus(scope.row, true)"
              >通过</el-button
            >
            <el-button
              type="text"
              v-if="scope.row.reviewStatus == '待审核'"
              @click="updateStatus(scope.row, false)"
              >驳回</el-button
            >
            <el-button
              type="text"
              v-if="scope.row.reviewStatus == '已通过'"
              @click="toVisit(scope.row)"
              >录入带看</el-button
            >
          </div>
          <div v-if="reservatStatus == 'visit'">
            <el-button type="text" @click="edit(scope.row, 'visit')"
              >修改</el-button
            >
            <el-button
              type="text"
              v-if="scope.row.reviewStatus == '待审核'"
              @click="updateStatus(scope.row, true)"
              >通过</el-button
            >
            <el-button
              type="text"
              v-if="scope.row.reviewStatus == '待审核'"
              @click="updateStatus(scope.row, false)"
              >驳回</el-button
            >
            <el-button
              type="text"
              v-if="scope.row.reviewStatus == '已通过'"
              @click="toVisit(scope.row)"
              >录入带看</el-button
            >
            <el-button
              type="text"
              v-if="scope.row.reviewStatus == '已通过'"
              @click="showAddRecognition(scope.row)"
              >认购</el-button
            >
          </div>
          <div v-if="reservatStatus == 'recognition'">
            <el-button type="text" @click="edit(scope.row, 'recognition')"
              >修改</el-button
            >
            <el-button
              type="text"
              v-if="scope.row.reviewStatus == '待审核'"
              @click="updateStatus(scope.row, true)"
              >通过</el-button
            >
            <el-button
              type="text"
              v-if="scope.row.reviewStatus == '待审核'"
              @click="updateStatus(scope.row, false)"
              >驳回</el-button
            >
            <el-button
              type="text"
              v-if="scope.row.reviewStatus == '已通过'"
              @click="netsign(scope.row)"
              >签约</el-button
            >
            <el-button
              type="text"
              v-if="scope.row.reviewStatus == '已通过'"
              @click="refund(scope.row)"
              >退订</el-button
            >
          </div>
          <div v-if="reservatStatus == 'netSign'">
            <el-button type="text" @click="edit(scope.row)">详情</el-button>
            <el-button
              type="text"
              v-if="scope.row.reviewStatus == '待审核'"
              @click="updateStatus(scope.row, true)"
              >通过</el-button
            >
            <el-button
              type="text"
              v-if="scope.row.reviewStatus == '待审核'"
              @click="updateStatus(scope.row, false)"
              >驳回</el-button
            >
            <el-button
              type="text"
              v-if="scope.row.reviewStatus == '已通过'"
              @click="commission(scope.row)"
              >结佣</el-button
            >
            <el-button
              type="text"
              v-if="scope.row.reviewStatus == '已通过'"
              @click="refund(scope.row)"
              >退订</el-button
            >
          </div>
          <div v-if="reservatStatus == 'commission'">
            <el-button type="text" @click="edit(scope.row)">详情</el-button>
            <el-button type="text" @click="updateStatus(scope.row, true)"
              >通过</el-button
            >
            <el-button type="text" @click="updateStatus(scope.row, false)"
              >驳回</el-button
            >
            <el-button type="text" @click="refund(scope.row)">退订</el-button>
          </div>
          <div v-if="reservatStatus == '全部'">
            <el-button type="text" @click="edit(scope.row)">详情</el-button>
          </div>
        </template>
      </el-table-column>
      <template slot="empty">
        <div class="loading-box" v-if="isLoading">
          <img
            src="@/assets/image/loading.png"
            alt="loading"
            class="loading-ico"
          />
          数据加载中...
        </div>
        <div class="empty-box" v-if="!isLoading && !reservationList.length">
          列表为空
        </div>
      </template>
    </el-table>
    <el-pagination
      class="pagination"
      @size-change="handleSizeChange"
      @current-change="handleCurrentChange"
      :current-page.sync="pageIndex"
      :page-sizes="[20, 30, 50, 100]"
      :page-size="query.maxResultCount"
      layout="total, sizes, prev, pager, next, jumper"
      :total="totalCount"
    ></el-pagination>
    <el-dialog
      title="报备信息"
      :before-close="copyClose"
      :visible.sync="isShowCopy"
      width="700px"
      class="dialog-copy dialog-auto dialog-basic"
    >
      <div id="copyInfo">
        <div class="copy-info">
          <div class="tit">报备项目：</div>
          <div class="val">{{ reservatInfo.estateName }}</div>
        </div>
        <div class="copy-info">
          <div class="tit">客户姓名：</div>
          <div class="val">{{ reservatInfo.customerName }}</div>
        </div>
        <div class="copy-info">
          <div class="tit">客户电话：</div>
          <div class="val">{{ reservatInfo.customerPhoneNumber }}</div>
        </div>
        <div class="copy-info">
          <div class="tit">报备人：</div>
          <div class="val">{{ reservatInfo.creatorName }}</div>
        </div>
        <div class="copy-info">
          <div class="tit">报备人电话：</div>
          <div class="val">{{ reservatInfo.creatorPhoneNumber }}</div>
        </div>
        <div class="copy-info">
          <div class="tit">公司名称：</div>
          <div class="val">{{ reservatInfo.organizationUnit }}</div>
        </div>
        <div class="copy-info">
          <div class="tit">报备时间：</div>
          <div class="val">{{ reservatInfo.creationTime }}</div>
        </div>
        <div class="copy-info">
          <div class="tit">到访时间：</div>
          <div class="val">{{ reservatInfo.visitTime }}</div>
        </div>
        <div class="copy-info">
          <div class="tit">来访人数：</div>
          <div class="val">{{ reservatInfo.visitPersonNumber }}</div>
        </div>
        <pre class="content" id="content" v-show="false">
报备项目：{{ reservatInfo.estateName }}
客户姓名：{{ reservatInfo.customerName }}
客户电话：{{ reservatInfo.customerPhoneNumber }}
报备人：{{ reservatInfo.creatorName }}
报备人电话：{{ reservatInfo.creatorPhoneNumber }}
公司名称：{{ reservatInfo.organizationUnit }}
报备时间：{{ reservatInfo.creationTime }}
到访时间：{{ reservatInfo.visitTime }}
来访人数：{{ reservatInfo.visitPersonNumber }}          
        </pre>
      </div>
      <div slot="footer" class="dialog-footer">
        <el-button @click="isShowCopy = false">取消</el-button>
        <el-button type="primary" @click="copy">确认复制</el-button>
      </div>
    </el-dialog>

    <el-dialog
      title="退订"
      width="530px"
      :before-close="refund"
      :visible.sync="isShowRefund"
      class="dialog-reason dialog-auto dialog-basic"
    >
      <el-input
        class="reason-box reason"
        type="textarea"
        v-model="reason"
        maxlength="200"
        placeholder="请输入退订原因"
        show-word-limit
        resize="none"
      ></el-input>
      <div slot="footer" class="dialog-footer">
        <el-button @click="refund">取消</el-button>
        <el-button type="primary" @click="submitRefund" :loading="submitLoading"
          >确认</el-button
        >
      </div>
    </el-dialog>
    <el-dialog
      title="报备驳回"
      width="610px"
      :before-close="showReject"
      :visible.sync="isShowReject"
      class="dialog-reason dialog-auto dialog-basic"
    >
      <el-input
        type="textarea"
        v-model="reason"
        maxlength="200"
        placeholder="请输入驳回原因"
        show-word-limit
        resize="none"
      ></el-input>
      <div slot="footer" class="dialog-footer">
        <el-button @click="showReject">取消</el-button>
        <el-button type="primary" @click="submitReject">确认</el-button>
      </div>
    </el-dialog>
    <el-dialog
      title="认购"
      width="610px"
      :before-close="showAddRecognition"
      :visible.sync="isShowAddRecognition"
      class="dialog-recognition dialog-auto dialog-basic"
    >
      <el-form
        :model="recognitionInfo"
        ref="recognitionInfo"
        label-width="6rem"
        label-position="left"
      >
        <el-form-item prop="Number" label="数量" class="auto-height">
          <el-input
            class="reason-box"
            v-model="recognitionInfo.Number"
            type="number"
          >
            <template slot="append">套</template>
          </el-input>
        </el-form-item>
        <el-form-item label="认筹/购材料" class="auto-height">
          <div class="visit-img">
            <div
              class="photo-item"
              v-for="(item, index) in recognitionInfo.Files"
              :key="index"
            >
              <div class="img-box">
                <img :src="item.url" class="photo-img" />
                <div class="del-btn">
                  <span @click="delPhotoItme(index)">删除</span>
                </div>
              </div>
            </div>
            <el-upload
              ref="upload"
              action="https://jsonplaceholder.typicode.com/posts/"
              :on-change="handlePictureCardPreview"
              :file-list="recognitionInfo.Files"
              :show-file-list="false"
              :auto-upload="false"
              multiple
              accept=".jpg, .png, .jpeg"
            >
              <div class="upload-btn">
                <i slot="default" class="el-icon-plus"></i>
                <span>最多上传5张图片</span>
              </div>
            </el-upload>
          </div>
        </el-form-item>
        <el-form-item prop="more" label="备注" class="auto-height">
          <el-input
            class="reason-box"
            type="textarea"
            v-model="recognitionInfo.More"
            maxlength="200"
            placeholder="请输入备注"
            show-word-limit
            resize="none"
          ></el-input>
        </el-form-item>
      </el-form>

      <div slot="footer" class="dialog-footer">
        <el-button @click="showAddRecognition">取消</el-button>
        <el-button
          type="primary"
          @click="submitRecognitionInfo"
          :loading="submitLoading"
          >确认</el-button
        >
      </div>
    </el-dialog>

    <el-dialog
      title="签约"
      width="610px"
      custom-class="dialog-netSign"
      :before-close="netsign"
      :visible.sync="isShowAddNetSign"
      class="dialog-reason dialog-recognition dialog-auto dialog-basic"
    >
      <el-form
        :model="netSignInfo"
        ref="netSignInfo"
        label-width="6rem"
        label-position="left"
      >
        <el-form-item prop="houseInfos" label="房源" class="auto-height">
          <div class="build-tit">{{ reservatInfo.estateName }}</div>
          <div class="house-info">
            <el-input v-model="netSignInfo.buildingNumber"></el-input
            ><span class="unit">栋</span>
            <el-input v-model="netSignInfo.unitNumber"></el-input
            ><span class="unit">单元</span>
            <el-input v-model="netSignInfo.houseNumber"></el-input
            ><span class="unit">号</span>
          </div>
        </el-form-item>
        <el-form-item prop="more" label="签约日期" class="auto-height">
          <el-date-picker
            v-model="netSignInfo.netSignTime"
            type="date"
            placeholder="选择日期"
          >
          </el-date-picker>
        </el-form-item>
        <el-form-item prop="price" label="签约价格" class="auto-height">
          <el-input
            class="reason-box"
            v-model="netSignInfo.price"
            type="number"
          >
            <template slot="append">万元</template>
          </el-input>
        </el-form-item>
        <el-form-item label="签约材料" class="auto-height">
          <div class="visit-img">
            <div
              class="photo-item"
              v-for="(item, index) in netSignFiles"
              :key="index"
            >
              <div class="img-box">
                <img :src="item.url" class="photo-img" />
                <div class="del-btn">
                  <span @click="delNetSignPhotoItme(index)">删除</span>
                </div>
              </div>
            </div>
            <el-upload
              ref="upload"
              action="https://jsonplaceholder.typicode.com/posts/"
              :on-change="handleNetSignPreview"
              :file-list="netSignFiles"
              :show-file-list="false"
              :auto-upload="false"
              multiple
              accept=".jpg, .png, .jpeg"
            >
              <div class="upload-btn">
                <i slot="default" class="el-icon-plus"></i>
                <span>最多上传5张图片</span>
              </div>
            </el-upload>
          </div>
        </el-form-item>
        <el-form-item prop="more" label="备注" class="auto-height">
          <el-input
            class="reason-box"
            type="textarea"
            v-model="netSignInfo.More"
            maxlength="200"
            placeholder="请输入备注"
            show-word-limit
            resize="none"
          ></el-input>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="netsign">取消</el-button>
        <el-button
          type="primary"
          :loading="submitLoading"
          @click="submitNetSign"
          >确认</el-button
        >
      </div>
    </el-dialog>

    <el-dialog
      title="结佣"
      width="610px"
      :before-close="commission"
      :visible.sync="isShowAddCommission"
      class="dialog-recognition dialog-auto dialog-basic"
    >
      <el-form
        :model="commissionInfo"
        ref="commissionInfo"
        label-width="6rem"
        label-position="left"
      >
        <el-form-item label="结佣材料" class="auto-height">
          <div class="visit-img">
            <div
              class="photo-item"
              v-for="(item, index) in commissionInfo.Files"
              :key="index"
            >
              <div class="img-box">
                <img :src="item.url" class="photo-img" />
                <div class="del-btn">
                  <span @click="delCommissionPhotoItme(index)">删除</span>
                </div>
              </div>
            </div>
            <el-upload
              ref="upload"
              action="https://jsonplaceholder.typicode.com/posts/"
              :on-change="handleCommissionPreview"
              :file-list="commissionInfo.Files"
              :show-file-list="false"
              :auto-upload="false"
              multiple
              accept=".jpg, .png, .jpeg"
            >
              <div class="upload-btn">
                <i slot="default" class="el-icon-plus"></i>
                <span>最多上传5张图片</span>
              </div>
            </el-upload>
          </div>
        </el-form-item>
        <el-form-item prop="more" label="备注" class="auto-height">
          <el-input
            class="reason-box"
            type="textarea"
            v-model="commissionInfo.More"
            maxlength="200"
            placeholder="请输入备注"
            show-word-limit
            resize="none"
          ></el-input>
        </el-form-item>
      </el-form>

      <div slot="footer" class="dialog-footer">
        <el-button @click="commission">取消</el-button>
        <el-button
          type="primary"
          @click="submitCommissionInfo"
          :loading="submitLoading"
          >确认</el-button
        >
      </div>
    </el-dialog>
  </div>
</template>

<script>
import reservatJs from "./reservatJS.js";
export default {
  ...reservatJs,
};
</script>
<style scoped lang='scss'>
@import "@/styles/mixin.scss";
.reservat {
  ::v-deep .waiting-item {
    width: 100%;
    .el-tabs {
      width: 100%;
      .el-tabs__item {
        margin-right: 12px;
        border-radius: 4px 4px 0 0;
        padding: 0 30px;
        height: 40px;
        line-height: 40px;
        font-size: 14px;
        border-bottom: 0;
        color: #333;
        background: #f7f7f7;
        &:hover {
          color: #fff;
          background: $--color-primary;
          opacity: 0.9;
        }
      }
      .is-active {
        border-bottom: 0;
        color: #fff;
        background: $--color-primary;
      }
      .el-tabs__nav-scroll {
        padding-left: 0;
        border-bottom: 2px solid $--color-primary;
      }
    }
    .el-badge__content {
      // top: -100px;
      z-index: 99;
      left: 148px;
      right: auto;
    }
  }
  .main-filter {
    .filter {
      @include flex(row, center);
      justify-content: space-between;
      margin-bottom: 20px;

      ::v-deep .input-with-select {
        margin-right: 20px;
        width: 440px;
        .el-input-group__prepend {
          width: 110px;
          .el-input__inner {
            width: 110px;
          }
        }
        .el-input__inner {
          width: 270px;
        }
      }
      .filter-type {
        width: 160px;
      }
      .filter-btn {
        margin-right: 10px;
      }
      .delete-btn {
        color: #717171;
      }
      .el-icon-delete {
        margin-right: 5px;
      }
    }
    .filter-select {
      @include flex(row, center);
      flex-wrap: wrap;
      margin-left: -20px;
      .filter-tit {
        margin: 0 20px;
        color: #717171;
      }
      .filter-item {
        margin-bottom: 20px;
      }
    }
  }
  ::v-deep .el-tabs {
    border: 0px;
    box-shadow: 0 2px 4px 0 rgba(0, 0, 0, 0), 0 0 6px 0 rgba(0, 0, 0, 0);

    .el-tabs__item {
      margin-right: 10px;
      border-bottom: 0;
      height: 30px;
      line-height: 30px;
      color: #717171;
      background: #f7f7f7;
      &:hover {
        color: #fff;
        background: $--color-primary;
        opacity: 0.9;
      }
    }
    .isactive {
      border-bottom: 0;
      color: #fff;
      background: $--color-primary;
    }
    .el-tabs__nav-scroll {
      padding-left: 0;
      border-bottom: 1px solid $--color-primary;
    }
    .el-tabs__header {
      box-shadow: 0 2px 4px 0 rgba(0, 0, 0, 0), 0 0 6px 0 rgba(0, 0, 0, 0);
    }
  }
  .el-table {
    margin-bottom: 20px;
    .success {
      color: #74c55c;
    }
    .error {
      color: #999;
    }
    .waiting {
      color: #409eff;
    }
    .todetails {
      color: $--color-primary;
      cursor: pointer;
    }
  }
}
::v-deep .dialog-copy {
  .el-dialog__body {
    width: 650px;
  }
  #copyInfo {
    width: 650px;
    .copy-info {
      @include flex(row, center);
      float: left;
      margin-bottom: 20px;
      width: 50%;
      .tit {
        margin-right: 5px;
        color: #717171;
      }
    }
  }
}
.dialog-reason {
  .reason-box {
    width: 100%;
  }
}
.dialog-recognition {
  ::v-deep .visit-img {
    @include flex(row, center);
    flex-wrap: wrap;
    .el-upload {
      border: 1px dashed #e0e0e0;
      border-radius: $--border-radius-base;
      width: 124px;
      height: 84px;
      line-height: 84px;
      .upload-btn {
        @include flex(column, center);
        justify-content: center;
        height: 84px;
        line-height: 84px;
        color: #858585;
        .el-icon-plus {
          font-size: 20px;
        }
        span {
          height: 30px;
          line-height: 30px;
          font-size: 12px;
        }
      }
    }
    .photo-item {
      position: relative;
      margin-right: 20px;
      margin-bottom: 5px;
      width: 124px;
      height: 84px;
      line-height: 84px;
      transition: all 0.4s;
      .del-btn {
        position: absolute;
        top: 0;
        left: 0;
        width: 124px;
        height: 84px;

        background-color: transparent;
        transition: all 0.4s;
        span {
          position: absolute;
          right: 5px;
          bottom: 5px;
          height: 14px;
          line-height: 14px;
          cursor: pointer;
          color: transparent;
        }
      }

      &:hover {
        .del-btn {
          background-color: rgba(0, 0, 0, 0.5);
          span {
            color: #fff;
          }
        }
      }

      img {
        width: 124px;
        height: 84px;
      }
    }
  }
}
.dialog-netSign {
  .build-tit {
    font-size: 14px;
    color: #000;
  }
  .house-info {
    @include flex(row, center);
    margin-bottom: 10px;
    .el-input {
      width: 60px;
    }
    .unit {
      margin: 0 8px;
      color: #7d7d7d;
    }
    .el-button {
      &:hover {
        color: $--color-primary;
      }
    }
    .delete {
      display: none;
    }
    &:hover {
      .delete {
        display: block;
      }
    }
  }
  .house-info:last-child {
    margin-bottom: 0;
  }
}
</style>